import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[hidden]'
})
export class HiddenDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @Input('hidden') set setHidden(value: boolean) {
    if (value) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'display');
    }
  }
}
